import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Stack,
  Badge,
  Icon,
  SimpleGrid,
  List,
  ListItem,
  ListIcon,
  Image,
  IconButton,
  useColorMode,
  useColorModeValue,
  Button,
  Divider,
  VStack,
  Grid,
  useBreakpointValue,
} from "@chakra-ui/react";
import { DiDart } from "react-icons/di";
import {
  FaCheckCircle,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaReact,
  FaNodeJs,
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaBootstrap,
  FaFigma,
  FaPython,
  FaGitAlt,
  FaCloud,
  FaDatabase,
  FaAws,
  FaGithub,
  FaDocker,
  FaKey,
  FaDownload,
} from "react-icons/fa";
import {
  SiAdobexd,
  SiChakraui,
  SiCplusplus,
  SiCsharp,
  SiDjango,
  SiExpress,
  SiFlutter,
  SiFramer,
  SiMongodb,
  SiNextdotjs,
  SiSwagger,
  SiTypescript,
  SiPostgresql,
  SiTailwindcss,
  SiRedux,
  SiGoland,
  SiNestjs,
  SiFirebase,
  SiGraphql,
  SiAmazonaws,
  SiKubernetes,
  SiReduxsaga,
  SiTestinglibrary,
  SiJest,
  SiPrisma,
  SiOpenai,
  SiVercel,
  SiStorybook,
  SiJupyter,
  SiFastapi,
  SiVite,
  SiAzuredevops,
  SiApollographql,
  SiSequelize,
} from "react-icons/si";
import { IoIosCloudyNight } from "react-icons/io";
import { ExternalLinkIcon } from "@chakra-ui/icons";

const ExperienceSection = () => {
  const bg = useColorModeValue("gray.50", "gray.800");
  const textColor = useColorModeValue("gray.800", "whiteAlpha.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  const experiences = [
    {
      title: "Full Stack Developer | .NET Core | ReactJS",
      description: "Social media management platform (2025-Onwards)",
      techStack: [
        { name: "C#", icon: SiCsharp },

        { name: "Next.js", icon: SiNextdotjs },
        { name: "ReactJS", icon: FaReact },
        { name: "TypeScript", icon: SiTypescript },
        { name: "OpenAI API", icon: SiOpenai },
        {
          name: "API Integration",
          icon: SiApollographql,
          label: "GraphQL/REST",
        },
        {
          name: ".NET Core",
          image:
            "https://img.icons8.com/?size=100&id=o0pte3XTuPWi&format=png&color=000000",
        },
        { name: "Git/GitHub", icon: FaGithub },
        { name: "CI/CD", icon: SiAzuredevops },
        { name: "Vercel", icon: SiVercel },
        { name: "Framer Motion", icon: SiFramer },
      ],
      details:
        "Build a social media management platform for managing Social media (Facebook, Instagram, X, LinkedIn, etc.) from one unified dashboard. Integrated various API's, built workflows, created unique UI designs, to make this app market competitive. The tech stack is .NET Core, and ReactJS. Later, utilized n8n automated workflows for creating workflows tailored to the app's unique requirements.",
    },
     {
      title: "Frontend Software Engineer & UI/UX Designer",
      description: "Upwork | Remote (2023–2024)",
      techStack: [
        { name: "ReactJS", icon: FaReact },
        { name: "Next.js", icon: SiNextdotjs },
        { name: "Node.js", icon: FaNodeJs },
        //{ name: "NestJS", icon: SiNestjs },
        //{ name: "TypeScript", icon: SiTypescript },
        //{ name: "Prisma ORM", icon: SiPrisma },
        { name: "MongoDB", icon: SiMongodb },
        { name: "PostgreSQL", icon: SiPostgresql },
        //{ name: "Firebase", icon: SiFirebase },
        { name: "Chakra UI", icon: SiChakraui },
        { name: "Tailwind CSS", icon: SiTailwindcss },
        //{ name: "Docker", icon: FaDocker },
        //{ name: "AWS", icon: SiAmazonaws },
        //{ name: "Vercel", icon: SiVercel },
      ],
      details:
        "Built POS Restaurant application with React, and React Native. Created and integrated APIs and microservices using JavaScript. Designed clean and modern user interfaces with Chakra UI, Tailwind CSS, and Figma. Integrated third-party services like Stripe, Firebase, and Google APIs.",
    },
    {
      title: "Software Engineer & UI/UX Designer",
      description: "Upwork",
      techStack: [
        { name: "ReactJS", icon: FaReact },
        { name: "Next.js", icon: SiNextdotjs },
        { name: "Node.js", icon: FaNodeJs },
        { name: "NestJS", icon: SiNestjs },
        { name: "TypeScript", icon: SiTypescript },
        { name: "Prisma ORM", icon: SiPrisma },
        { name: "MongoDB", icon: SiMongodb },
        { name: "PostgreSQL", icon: SiPostgresql },
        { name: "Firebase", icon: SiFirebase },
        { name: "Chakra UI", icon: SiChakraui },
        { name: "Tailwind CSS", icon: SiTailwindcss },
        { name: "Docker", icon: FaDocker },
        { name: "AWS", icon: SiAmazonaws },
        { name: "Vercel", icon: SiVercel },
      ],
      details:
        "Led the design and development of cloud-native SaaS platforms, integrating real-time microservices, serverless APIs, authentication, payments, and dynamic dashboards. Advocated for clean architecture and component-driven development.",
    },
    {
      title: "Full Stack Engineer – AutoAid (2025)",
      description: "Roadside Assistance Mobile & Web App (Founder/Lead Dev)",
      techStack: [
        { name: "Flutter", icon: SiFlutter },
        { name: "React Native", icon: FaReact },
        { name: "Node.js", icon: FaNodeJs },
        { name: "Express.js", icon: SiExpress },
        { name: "PostgreSQL", icon: SiPostgresql },
        { name: "TypeORM", icon: SiTypescript },
        { name: "JWT Auth", icon: FaKey },
        { name: "Socket.IO", icon: FaCloud },
        { name: "Google Maps API", icon: FaMapMarkerAlt },
        { name: "Firebase Cloud Messaging", icon: SiFirebase },
      ],
      details:
        "Architected and shipped a scalable cross-platform app for real-time roadside assistance. Implemented real-time geolocation, push notifications, in-app chat, and robust admin dashboards. ",
    },
    {
      title: "Technical Blog & Prompt Engineering",
      description: "Content Creator & Prompt Engineer (2023–2025)",
      techStack: [
        { name: "Jupyter", icon: SiJupyter },
        { name: "Python", icon: FaPython },
        { name: "OpenAI API", icon: SiOpenai },
        { name: "FastAPI", icon: SiFastapi },
      ],
      details:
        "Wrote in-depth technical blogs on JavaScript, React, prompt engineering, and AI integration. Delivered educational content on building LLM-powered apps and deploying production-grade SaaS.",
    },
    {
      title: "Legacy/Academic Projects",
      description: "C++, Figma & Design Systems",
      techStack: [
        { name: "ReactJS", icon: FaReact },
        { name: "Next.js", icon: SiNextdotjs },
        { name: "Node.js", icon: FaNodeJs },
        { name: "NestJS", icon: SiNestjs },
        { name: "TypeScript", icon: SiTypescript },
        { name: "Prisma ORM", icon: SiPrisma },
        { name: "MongoDB", icon: SiMongodb },
        { name: "PostgreSQL", icon: SiPostgresql },
        { name: "Firebase", icon: SiFirebase },
        { name: "Chakra UI", icon: SiChakraui },
        { name: "Tailwind CSS", icon: SiTailwindcss },
        { name: "Docker", icon: FaDocker },
        { name: "AWS", icon: SiAmazonaws },
        { name: "Vercel", icon: SiVercel },
        { name: "C++", icon: SiCplusplus },
        { name: "Figma", icon: FaFigma },
        { name: "Adobe XD", icon: SiAdobexd },
      ],
      details:
        "Developed desktop tools, small-scale projects , and complete mobile/web UI systems during undergrad studies.",
    },
  ];

  return (
    <Box>
      <Heading as="h2" size="lg" mb={4}>
        Experience
      </Heading>
      <Stack spacing={8}>
        {experiences.map((exp, index) => (
          <Box
            key={index}
            py={4}
            borderRadius="lg"
            border="1px solid"
            borderColor={borderColor}
            px={4}
          >
            <VStack align="start" spacing={2} width="100%">
              <Flex
                justify="space-between"
                width="100%"
                align={{ base: "flex-start", md: "center" }}
                wrap="wrap"
                mb={1}
              >
                <Text fontSize="lg" fontWeight="bold" color={textColor}>
                  {exp.title}
                </Text>
                <Text fontSize="sm" color="gray.500">
                  {exp.description}
                </Text>
              </Flex>
              <Divider my={1} />
              <Text fontSize="sm" color={textColor}>
                {exp.details}
              </Text>
              <Flex wrap="wrap" mt={2}>
                {exp.techStack.map((tech, idx) => (
                  <Flex
                    key={idx}
                    align="center"
                    mr={4}
                    mt={2}
                    p={1.5}
                    border="1px solid"
                    borderColor={borderColor}
                    borderRadius="full"
                    color={textColor}
                    minW="120px"
                  >
                    <Icon as={tech.icon} w={4} h={4} />
                    <Text ml={2} fontSize="xs">
                      {tech.name}
                    </Text>
                  </Flex>
                ))}
              </Flex>
            </VStack>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

const Resume = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const bg = useColorModeValue("white", "gray.800");
  const color = useColorModeValue("gray.800", "whiteAlpha.900");
  const dividerColor = useColorModeValue("gray.300", "gray.600");
  const cardBg = useColorModeValue("white", "gray.700");
  const headingColor = useColorModeValue("gray.800", "whiteAlpha.900");
  const textColor = useColorModeValue("gray.800", "whiteAlpha.900");
  const iconColor = useColorModeValue("black", "white");

  const isMobile = useBreakpointValue({ base: true, md: false });

  // Expanded skill set (2024–2025)
  const skills = [
    { name: "C#", icon: SiCsharp },
    { name: "C++", icon: SiCplusplus },
    { name: "JavaScript", icon: FaJs },
    { name: "TypeScript", icon: SiTypescript },
    //{ name: "Python", icon: FaPython },
    //{ name: "Dart", icon: DiDart },
    { name: "Node.js", icon: FaNodeJs },
    {
      name: ".NET Core",
      image:
        "https://img.icons8.com/?size=100&id=o0pte3XTuPWi&format=png&color=000000",
    },
    { name: "Express.js", icon: SiExpress },
    { name: "ReactJS", icon: FaReact },
    { name: "Next.js", icon: SiNextdotjs },
    //{ name: "NestJS", icon: SiNestjs },
    { name: "Flutter", icon: SiFlutter },
    { name: "OpenAI API", icon: SiOpenai },
    { name: "API Integration", icon: SiApollographql, label: "GraphQL/REST" },
    { name: "MongoDB", icon: SiMongodb },
    { name: "PostgreSQL", icon: SiPostgresql },
    { name: "Sequelize", icon: SiSequelize },
    { name: "Prisma ORM", icon: SiPrisma },
    { name: "Firebase", icon: SiFirebase },
    { name: "FastAPI", icon: SiFastapi },
    { name: "AWS", icon: SiAmazonaws },
    { name: "Docker", icon: FaDocker },
    { name: "Kubernetes", icon: SiKubernetes },
    { name: "Git/GitHub", icon: FaGithub },
    //{ name: "CI/CD", icon: SiAzuredevops },
    { name: "Vercel", icon: SiVercel },
    { name: "Redux Toolkit", icon: SiRedux },
    { name: "Chakra UI", icon: SiChakraui },
    { name: "Tailwind CSS", icon: SiTailwindcss },
    { name: "Framer/Framer Motion", icon: SiFramer },
  ];

  return (
    <Box p={8} bg={bg} minH="100vh" color={color}>
      <Flex justifyContent="center" alignItems="center">
        <Box w="full" textAlign="left">
          <Flex justifyContent="space-between" alignItems="center" mb={8}>
            <Box>
              <Heading
                as="h1"
                size={{ base: "lg", md: "xl" }}
                color={headingColor}
                textAlign={{ base: "center", md: "left" }}
                mb={1}
              >
                Mohammad Abubakar
              </Heading>
              <Text
                fontSize="lg"
                color={color}
                textAlign={{ base: "center", md: "left" }}
                mb={2}
              >
                Software Engineer · Full Stack Developer · AI Automation &
                Agents · Prompt Engineer
              </Text>
              <Divider my={"4"} color={dividerColor} />
              <Stack spacing={0}>
                <Flex alignItems="center">
                  <Icon as={FaMapMarkerAlt} mr={2} />
                  <Text>Lahore, Pakistan</Text>
                </Flex>
                <Flex alignItems="center">
                  <Icon as={FaEnvelope} mr={2} />
                  <Text>moabubakar230@gmail.com</Text>
                </Flex>
              </Stack>
            </Box>
          </Flex>
          <IconButton
            as="a"
            href="/Resume.pdf"
            download
            aria-label="Download Resume"
            icon={<FaDownload />}
            size={isMobile ? "lg" : "xl"}
            colorScheme="teal"
            borderRadius="full"
            boxShadow="lg"
            zIndex={1000}
            sx={{
              position: "fixed",
              bottom: isMobile ? "18px" : "36px",
              right: isMobile ? "18px" : "36px",
              width: isMobile ? "56px" : "66px",
              height: isMobile ? "56px" : "66px",
              background: "white",
              color: "#319795", // Chakra's teal.500
              transition: "box-shadow .18s, transform .18s",
              _hover: {
                boxShadow: "0 0 20px #31979544",
                transform: "scale(1.08)",
                background: "#319795",
                color: "white",
              },
            }}
          />
          <Box mb={8}>
            <Heading as="h2" size="lg" mb={4} color={headingColor}>
              Profile
            </Heading>
            <Text textAlign="justify" fontSize="md" color={textColor}>
              Hi, I'm Mohammad Abubakar, a passionate Software Engineer
              specializing in full-stack development, and in AI Automation &
              Agents. With a strong foundation in computer science and hands-on
              experience in building scalable SaaS applications, I thrive on
              transforming complex problems into elegant solutions. My expertise
              spans modern web technologies, cloud-native architectures, and AI
              Automations & integration. I'm dedicated to continuous learning
              and innovation, always eager to explore new technologies and
              contribute to impactful projects.
            </Text>
          </Box>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} mb={8}>
            <Box>
              <Heading as="h3" size="md" mb={4} color={headingColor}>
                Education
              </Heading>
              <List spacing={3} textAlign="justify">
                <ListItem>
                  <ListIcon as={FaCheckCircle} color="green.500" />
                  BS Computer Science, University of South Asia, Lahore
                  (2021–2025)
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheckCircle} color="green.500" />
                  FSc Pre-Engineering, Punjab College, Lahore (2019–2021)
                </ListItem>
                <ListItem>
                  <ListIcon as={FaCheckCircle} color="green.500" />
                  Matriculation (Computer Science), Unique High School, Lahore
                  (2017–2019)
                </ListItem>
              </List>
            </Box>
            <Box>
              <Heading as="h3" size="md" mb={4} color={headingColor}>
                Certifications & Courses
              </Heading>
              <List spacing={3} textAlign="justify">
                <ListItem>
                  <Flex align="center">
                    <ListIcon as={FaCheckCircle} color="green.500" />
                    <Flex align="center" gap={2}>
                      <Text>
                        Google: Build Wireframes and Low-Fidelity Prototypes
                        (Coursera, 2022)
                      </Text>
                      <IconButton
                        as="a"
                        href="https://www.coursera.org/account/accomplishments/certificate/PWHKWB6BBZ4F"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="View credential"
                        icon={<ExternalLinkIcon />}
                        size="sm"
                        variant="ghost"
                      />
                    </Flex>
                  </Flex>
                </ListItem>
                <ListItem>
                  <Flex align="center">
                    <ListIcon as={FaCheckCircle} color="green.500" />
                    <Flex align="center" gap={2}>
                      <Text>
                        Google: Conduct UX Research and Test Early Concepts
                        (Coursera, 2022)
                      </Text>
                      <IconButton
                        as="a"
                        href="https://www.coursera.org/account/accomplishments/certificate/FL3ZFWV7ZGCP"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="View credential"
                        icon={<ExternalLinkIcon />}
                        size="sm"
                        variant="ghost"
                      />
                    </Flex>
                  </Flex>
                </ListItem>
                <ListItem>
                  <Flex align="center">
                    <ListIcon as={FaCheckCircle} color="green.500" />
                    <Flex align="center" gap={2}>
                      <Text>
                        Google: Create High-Fidelity Designs and Prototypes in
                        Figma (Coursera, 2022)
                      </Text>
                      <IconButton
                        as="a"
                        href="https://www.coursera.org/account/accomplishments/certificate/AY65CCXMEYUG"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="View credential"
                        icon={<ExternalLinkIcon />}
                        size="sm"
                        variant="ghost"
                      />
                    </Flex>
                  </Flex>
                </ListItem>
                <ListItem>
                  <Flex align="center">
                    <ListIcon as={FaCheckCircle} color="green.500" />
                    <Flex align="center" gap={2}>
                      <Text>
                        Google: Foundations of User Experience (UX) Design
                        (Coursera, 2022)
                      </Text>
                      <IconButton
                        as="a"
                        href="https://www.coursera.org/account/accomplishments/certificate/LZLJZCXK8U8"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="View credential"
                        icon={<ExternalLinkIcon />}
                        size="sm"
                        variant="ghost"
                      />
                    </Flex>
                  </Flex>
                </ListItem>
                <ListItem>
                  <Flex align="center">
                    <ListIcon as={FaCheckCircle} color="green.500" />
                    <Flex align="center" gap={2}>
                      <Text>
                        Google: Start the UX Design Process: Empathize, Define,
                        and Ideate (Coursera, 2022)
                      </Text>
                      <IconButton
                        as="a"
                        href="https://www.coursera.org/account/accomplishments/certificate/M2ZR34X2B3N3"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="View credential"
                        icon={<ExternalLinkIcon />}
                        size="sm"
                        variant="ghost"
                      />
                    </Flex>
                  </Flex>
                </ListItem>
              </List>
            </Box>
          </SimpleGrid>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} mb={8}>
            <Box>
              <Heading as="h3" size="md" mb={4} color={headingColor}>
                Skills & Technologies
              </Heading>
              <Grid
                templateColumns="repeat(auto-fit, minmax(120px, 1fr))"
                gap={2}
              >
                {skills.map((skill, index) => {
                  const Icon = skill.icon;
                  return (
                    <Box
                      key={index}
                      minWidth="120px"
                      maxWidth="200px"
                      p={4}
                      border="1px solid"
                      borderColor={color}
                      borderRadius="lg"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                    >
                      <Flex alignItems="center" justifyContent="center">
                        {skill.image ? (
                          <Image
                            src={skill.image}
                            alt={skill.name}
                            boxSize="18px"
                            objectFit="contain"
                          />
                        ) : (
                          <Icon size={18} color={iconColor} />
                        )}
                        <Text
                          ml={2}
                          fontSize="12"
                          fontWeight="medium"
                          color={textColor}
                        >
                          {skill.label || skill.name}
                        </Text>
                      </Flex>
                    </Box>
                  );
                })}
              </Grid>
            </Box>
            <Box>
              <Heading as="h3" size="md" mb={4} color={headingColor}>
                Hobbies & Languages
              </Heading>
              <Text mb={2}>Hobbies</Text>
              <Text textAlign="justify">
                Building SaaS products, open-source contributions, writing tech
                blogs, reading about AI, and exploring new startups.
              </Text>
              <Text mt={4} mb={2}>
                Languages
              </Text>
              <Text>Urdu (Native/Bilingual)</Text>
              <Text>English (Professional)</Text>
            </Box>
          </SimpleGrid>
        </Box>
      </Flex>
      <ExperienceSection />
    </Box>
  );
};

export default Resume;
